export default {
  documentFormats: [],
};
